var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "basic-single-report" },
    [
      _c(
        "header",
        { staticClass: "header" },
        [
          _c(
            "span",
            { staticClass: "header-back", on: { click: _vm.handleChange } },
            [
              _c("i", {
                staticClass: "el-icon-arrow-left",
                attrs: { "data-io-click": "tracker" },
              }),
              _vm._v("返回 "),
            ]
          ),
          _c("div", { staticClass: "report-button" }, [
            _vm.showClassReport
              ? _c(
                  "span",
                  {
                    class: _vm.isClassReport ? "menu-tab actived" : "menu-tab",
                    on: {
                      click: function ($event) {
                        return _vm.changeRouter("examine-classReport-basic")
                      },
                    },
                  },
                  [_vm._v("班级报告")]
                )
              : _vm._e(),
            _vm.showGradeReport
              ? _c(
                  "span",
                  {
                    class: !_vm.isClassReport ? "menu-tab actived" : "menu-tab",
                    on: {
                      click: function ($event) {
                        return _vm.changeRouter("examine-gradeReport-basic")
                      },
                    },
                  },
                  [_vm._v("校级报告")]
                )
              : _vm._e(),
          ]),
          _c("div", { staticStyle: { flex: "1" } }),
          _vm.$store.state.backDoor
            ? _c(
                "el-button",
                {
                  staticStyle: { height: "30px", "margin-top": "10px" },
                  attrs: { size: "mini", type: "danger" },
                  on: { click: _vm.markSchoolExam },
                },
                [_vm._v("优先打标")]
              )
            : _vm._e(),
          _c("div", { staticClass: "export-report" }, [
            _c("div", { staticStyle: { "margin-top": "10px" } }, [
              _c(
                "div",
                {
                  staticClass: "top",
                  on: {
                    click: function ($event) {
                      return _vm.showClassReportExportModal()
                    },
                  },
                },
                [_vm._m(0)]
              ),
              _c("div", { staticStyle: { height: "18px", clear: "both" } }),
            ]),
          ]),
          _c(
            "yue-dialog",
            {
              attrs: {
                title: "提示",
                visible: _vm.exportDialogVisible,
                size: "tiny",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.exportDialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        "text-align": "right",
                        color: "#333",
                        "font-size": "15px",
                        "line-height": "30px",
                      },
                      attrs: { span: 12 },
                    },
                    [
                      _vm.exportLoading
                        ? _c("span", [_vm._v("报表生成中")])
                        : _vm._e(),
                      !_vm.exportLoading ? _c("span") : _vm._e(),
                    ]
                  ),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _vm.exportLoading
                      ? _c("div", { staticClass: "spinner" }, [
                          _c("div", { staticClass: "bounce1" }),
                          _c("div", { staticClass: "bounce2" }),
                          _c("div", { staticClass: "bounce3" }),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              !_vm.exportLoading
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        "text-align": "center",
                        display: "inline-block",
                        width: "100%",
                      },
                      attrs: { download: "proposed_file_name" },
                      on: {
                        click: function ($event) {
                          _vm.exportDialogVisible = false
                        },
                      },
                    },
                    [
                      _vm._v(" 报表生成成功，点击 "),
                      _c(
                        "a",
                        {
                          staticStyle: {
                            "text-decoration": "underline",
                            color: "#2877FF",
                          },
                          attrs: { href: _vm.url },
                        },
                        [_vm._v("下载")]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "info-wrapper" },
        [
          _c("div", { staticClass: "info" }, [
            _c(
              "h4",
              { staticClass: "exam-name", attrs: { title: _vm.exam.examName } },
              [_vm._v(_vm._s(_vm.exam.examName))]
            ),
            _vm.exam.isMore === 1
              ? _c("div", { staticClass: "reletive" }, [
                  _c("img", {
                    attrs: { src: require("images/entrance_exam.png") },
                  }),
                  _c("span", [_vm._v("联考")]),
                ])
              : _vm.exam.isMore === 2
              ? _c("div", { staticClass: "reletive" }, [
                  _c("img", {
                    attrs: { src: require("images/region_exam.png") },
                  }),
                  _c("span", [_vm._v("区域统考")]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "date" }, [
              _c("img", {
                attrs: { src: require("images/time.png"), width: "16" },
              }),
              _c("label", [_vm._v(_vm._s(_vm.exam.date))]),
            ]),
            _c("div", { staticClass: "reletive" }, [
              _c("img", { attrs: { src: require("images/report-grade.png") } }),
              _c("span", [_vm._v(_vm._s(_vm.exam.gradeName))]),
            ]),
            _c("div", { staticClass: "reletive" }, [
              _c("img", {
                attrs: { src: require("images/report-subject.png") },
              }),
              _c("span", [_vm._v(_vm._s(_vm.exam.subjectName))]),
            ]),
            _vm.tongFenClassTip
              ? _c(
                  "div",
                  {
                    staticClass: "grading-tip",
                    attrs: { title: _vm.tongFenClassTip },
                  },
                  [_vm._v(" " + _vm._s(_vm.tongFenClassTip) + " ")]
                )
              : _vm._e(),
            _vm.userInfo.branchOfLearning == 1 &&
            (_vm.$route.name == "examine-gradeReport-basic" ||
              _vm.$route.name == "examine-gradeReport-comment" ||
              _vm.$route.name == "examine-gradeReport-transcript")
              ? _c(
                  "div",
                  { staticClass: "report-type" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          plain: _vm.branch == 1,
                        },
                        on: {
                          click: function ($event) {
                            _vm.branch = 2
                          },
                        },
                      },
                      [_vm._v("理科班")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          plain: _vm.branch == 2,
                        },
                        on: {
                          click: function ($event) {
                            _vm.branch = 1
                          },
                        },
                      },
                      [_vm._v("文科班")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm.showReport &&
          _vm.hasTeachType &&
          ((_vm.isTongFen && _vm.tongFenClassTip) || !_vm.isTongFen) &&
          _vm.exam.isMore !== 2
            ? _c(
                "div",
                {
                  staticClass: "model-dialog",
                  on: {
                    click: function ($event) {
                      {
                        if (_vm.isChangeReportType) {
                          _vm.reportModalDialog = true
                        }
                      }
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("images/report/class.png"),
                      height: "18",
                    },
                  }),
                  _c(
                    "span",
                    {
                      style: {
                        color:
                          "" + (_vm.isChangeReportType ? "#2877FF" : "#999999"),
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.reportType == 0 ? "行政班" : "教学班") +
                          " "
                      ),
                    ]
                  ),
                  _c("img", {
                    attrs: {
                      src: require("images/report/switch.png"),
                      height: "14",
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm.$route.name == "examine-classReport-comment"
            ? [
                _c(
                  "div",
                  { staticClass: "export_paper_report" },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          "padding-top": "8px",
                          "padding-bottom": "8px",
                        },
                        attrs: { round: "", size: "small", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.handlePaperReport(
                              "CLASS_EXAM_PAPER_INFO"
                            )
                          },
                        },
                      },
                      [_vm._v("试卷讲评报告")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _c("div", { staticClass: "tool" }, [
            _vm.isClassReport
              ? _c(
                  "div",
                  { staticClass: "select-round" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "mini", placeholder: "班级" },
                        model: {
                          value: _vm.classId,
                          callback: function ($$v) {
                            _vm.classId = $$v
                          },
                          expression: "classId",
                        },
                      },
                      _vm._l(_vm.classList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: {
                            label:
                              "" +
                              item.className +
                              (item.hasData ? "" : "(未扫描)"),
                            value: item.id,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass: "screen_login",
                    on: {
                      click: function ($event) {
                        return _vm.pathToScreen()
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("images/project_mode.png"),
                        width: "34",
                      },
                    }),
                    _c("span", [_vm._v("进入投影模式")]),
                  ]
                ),
            _vm.exam.isMore !== 2
              ? _c(
                  "a",
                  {
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function ($event) {
                        _vm.reportSettingVisible = true
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("images/setting.png"),
                        width: "24",
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        2
      ),
      _vm.showReport
        ? _c(
            "div",
            { staticClass: "main" },
            [
              _c(
                "div",
                { staticClass: "nav-wrap" },
                [
                  _c("nav-bar", {
                    class: _vm.fixedClass,
                    attrs: { routers: _vm.routers },
                  }),
                  _c("div", { staticClass: "qrcode" }, [
                    _vm.$store.getters.isTest
                      ? _c("img", {
                          attrs: { src: require("images/qrcode_testing.png") },
                        })
                      : _c("img", {
                          attrs: { src: require("images/qrcode.png") },
                        }),
                    _c("p", [_vm._v("手机阅卷并查看报告")]),
                  ]),
                ],
                1
              ),
              _c(
                "keep-alive",
                { attrs: { include: _vm.includeRoutes } },
                [
                  _c("router-view", {
                    attrs: {
                      param: _vm.param,
                      "grade-name": _vm.gradeName,
                      "grade-id": _vm.gradeId,
                      "class-list": _vm.classList,
                      "class-id": _vm.classId,
                      "class-name": _vm.className,
                      "exam-info": _vm.examInfo,
                      isExamSplit: _vm.isExamSplit,
                      "report-type": _vm.reportType,
                      branch: _vm.branch,
                      "dialog-class-info": _vm.dialogClassInfo,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.examLoading,
                  expression: "examLoading",
                },
              ],
              staticClass: "loading-bg",
            },
            [_c("p", [_vm._v(_vm._s(_vm.examLoadingMsg))])]
          ),
      _c(
        "yue-dialog",
        {
          staticClass: "report-setting",
          attrs: {
            title: "设置",
            width: "760px",
            center: "",
            visible: _vm.reportSettingVisible,
            "before-close": _vm.handleCloseSetting,
          },
          on: {
            "update:visible": function ($event) {
              _vm.reportSettingVisible = $event
            },
          },
        },
        [
          _c(
            "ul",
            { staticClass: "setting-nav" },
            _vm._l(
              _vm.navList.slice(0, _vm.isClassReport ? 3 : 4),
              function (item, index) {
                return _c(
                  "li",
                  {
                    key: item.name,
                    class: { active: index === _vm.navActive },
                    on: {
                      click: function ($event) {
                        return _vm.changeNav(index)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item.name) + " ")]
                )
              }
            ),
            0
          ),
          _vm.navTab === 0
            ? _c("div", { staticClass: "setting-body" }, [
                _c("p", { staticStyle: { height: "30px" } }, [
                  _vm._v("总分 " + _vm._s(_vm.param.totalScore || "--") + "分"),
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.paramLoading,
                        expression: "paramLoading",
                      },
                    ],
                    staticClass: "table-wrap",
                  },
                  [
                    _c(
                      "el-form",
                      { ref: "levelForm", attrs: { model: _vm.model } },
                      [
                        _c(
                          "el-table",
                          {
                            attrs: {
                              size: "small",
                              data: _vm.model.paramList,
                              border: "",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "rank",
                                align: "center",
                                label: "系统分数等级",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "percent",
                                align: "center",
                                label: "达到等级比例",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(_vm._s(scope.row.percent) + "%"),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                955610376
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "parent",
                                align: "center",
                                label: "家长显示名称",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "edit",
                                align: "center",
                                width: "180",
                                label: "本次考试修改",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "paramList." +
                                                scope.$index +
                                                ".edit",
                                              rules: _vm.model.rules.edit,
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass: "level-input",
                                              attrs: {
                                                size: "small",
                                                clearable: "",
                                              },
                                              model: {
                                                value: scope.row.edit,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "edit",
                                                    $$v
                                                  )
                                                },
                                                expression: "scope.row.edit",
                                              },
                                            }),
                                            _c("span", [_vm._v(" %")]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2226897164
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.navTab === 1
            ? _c(
                "div",
                { staticClass: "count-body" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "top-form",
                      attrs: {
                        "label-width": "240px",
                        "label-position": "left",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { size: "small", label: "缺考：" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.param.analMiss,
                                callback: function ($$v) {
                                  _vm.$set(_vm.param, "analMiss", $$v)
                                },
                                expression: "param.analMiss",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("参与"),
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("不参与"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { size: "small", label: "无名氏：" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.param.analNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.param, "analNo", $$v)
                                },
                                expression: "param.analNo",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("参与"),
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("不参与"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { size: "small", label: "0分卷：" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.param.analZero,
                                callback: function ($$v) {
                                  _vm.$set(_vm.param, "analZero", $$v)
                                },
                                expression: "param.analZero",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("参与"),
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("不参与"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            size: "small",
                            label: "考试报告是否显示综合分相关数据：",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.param.openComprehensive,
                                callback: function ($$v) {
                                  _vm.$set(_vm.param, "openComprehensive", $$v)
                                },
                                expression: "param.openComprehensive",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是    "),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.navTab === 2
            ? _c(
                "div",
                { staticClass: "matrixing" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "matrxingForm",
                      staticClass: "top-form",
                      attrs: {
                        model: _vm.matrixing,
                        rules: _vm.matrixingRules,
                        "label-width": "240px",
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "换算系数：", prop: "value" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "260px" },
                            attrs: {
                              type: "number",
                              placeholder: "默认值为1，最多支持两位小数",
                            },
                            model: {
                              value: _vm.matrixing.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.matrixing, "value", $$v)
                              },
                              expression: "matrixing.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.navTab === 3
            ? _c(
                "div",
                {
                  staticClass: "matrixing",
                  staticStyle: { padding: "40px 0 0 150px" },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: {
                        size: "mini",
                        model: _vm.gradeForm,
                        "label-width": "155px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "年级综合分" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.gradeForm.gradeSynthesisScore,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.gradeForm,
                                    "gradeSynthesisScore",
                                    $$v
                                  )
                                },
                                expression: "gradeForm.gradeSynthesisScore",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不显示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "与校均之差" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.gradeForm.schoolInequality,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.gradeForm,
                                    "schoolInequality",
                                    $$v
                                  )
                                },
                                expression: "gradeForm.schoolInequality",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不显示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "年级平均分" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.gradeForm.gradeAvg,
                                callback: function ($$v) {
                                  _vm.$set(_vm.gradeForm, "gradeAvg", $$v)
                                },
                                expression: "gradeForm.gradeAvg",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不显示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "年级分数等级" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.gradeForm.gradeScoreLevel,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.gradeForm,
                                    "gradeScoreLevel",
                                    $$v
                                  )
                                },
                                expression: "gradeForm.gradeScoreLevel",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不显示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "与年级均值的距离" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.gradeForm.gradeAvgDistance,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.gradeForm,
                                    "gradeAvgDistance",
                                    $$v
                                  )
                                },
                                expression: "gradeForm.gradeAvgDistance",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不显示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "每道题的年级占比" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.gradeForm.everyTopicPercent,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.gradeForm,
                                    "everyTopicPercent",
                                    $$v
                                  )
                                },
                                expression: "gradeForm.everyTopicPercent",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不显示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "个人难易题年级得分率" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.gradeForm.everyoneGradeScorePercent,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.gradeForm,
                                    "everyoneGradeScorePercent",
                                    $$v
                                  )
                                },
                                expression:
                                  "gradeForm.everyoneGradeScorePercent",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不显示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "年级名次" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.gradeForm.gradeRank,
                                callback: function ($$v) {
                                  _vm.$set(_vm.gradeForm, "gradeRank", $$v)
                                },
                                expression: "gradeForm.gradeRank",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不显示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "个人击败本校占比" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value:
                                  _vm.gradeForm.personalDefeatSchoolPercent,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.gradeForm,
                                    "personalDefeatSchoolPercent",
                                    $$v
                                  )
                                },
                                expression:
                                  "gradeForm.personalDefeatSchoolPercent",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不显示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "年级得分率" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.gradeForm.gradeScorePercent,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.gradeForm,
                                    "gradeScorePercent",
                                    $$v
                                  )
                                },
                                expression: "gradeForm.gradeScorePercent",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("显示"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("不显示"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "medium",
                    loading: _vm.saveParamLoading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm()
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "切换报告生成模式",
            visible: _vm.reportModalDialog,
            size: "small",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.reportModalDialog = $event
            },
          },
        },
        [
          _c("p", { staticClass: "report-modal-content" }, [
            _c("label", [_vm._v("当前为“")]),
            _c("span", [
              _vm._v(_vm._s(_vm.reportType == 0 ? "行政班" : "教学班")),
            ]),
            _c("label", [_vm._v("”分析模式，是否切换为“")]),
            _c("span", [
              _vm._v(_vm._s(_vm.reportType == 0 ? "教学班" : "行政班")),
            ]),
            _c("label", [_vm._v("”？")]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.reportModalDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.switchReportModal()
                    },
                  },
                },
                [_vm._v("切 换")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "yue-dialog",
        {
          attrs: {
            title:
              "导出" +
              (_vm.exportReportType === "CLASS_EXAM_PAPER_INFO"
                ? "试卷讲评"
                : "班级") +
              "报告",
            visible: _vm.dialogPaperReportVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogPaperReportVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "export-grade-report" },
            [
              _c("div", { staticClass: "export-grade-header" }, [
                _c(
                  "div",
                  [
                    _vm.exportReportType !== "CLASS_EXAM_PAPER_INFO"
                      ? [
                          _vm.schoolClassAllReport.state + "" != "2"
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "small",
                                    disabled:
                                      _vm.schoolClassAllReport.state + "" ===
                                      "1",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.createReportExport(
                                        _vm.schoolClassAllReport
                                      )
                                    },
                                  },
                                },
                                [_vm._v("一键生成")]
                              )
                            : _vm.schoolClassAllReport.state + "" === "2"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDownload(
                                        _vm.schoolClassAllReport
                                      )
                                    },
                                  },
                                },
                                [_vm._v("一键下载")]
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c(
                  "div",
                  [
                    _c("span", [_vm._v("点击刷新查看导出进度")]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handlePaperReport()
                          },
                        },
                      },
                      [_vm._v("刷新")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.paperReportExportLoading,
                      expression: "paperReportExportLoading",
                    },
                  ],
                  attrs: { size: "mini", data: _vm.paperReportData },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      property: "fileName",
                      align: "center",
                      label: "班级",
                      width: "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "导出状态", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.state + "" === "0"
                              ? _c("span", [_vm._v("等待处理")])
                              : scope.row.state + "" === "1"
                              ? _c("span", [_vm._v("处理中")])
                              : scope.row.state + "" === "2"
                              ? _c("span", [_vm._v("已完成")])
                              : scope.row.state + "" === "3"
                              ? _c("span", [_vm._v("处理失败")])
                              : _c("span", [_vm._v("未导出")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            ["2", "3", "4"].indexOf(scope.row.state + "") > -1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createReportExport(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("重新生成")]
                                )
                              : _vm._e(),
                            scope.row.state === null ||
                            scope.row.state + "" === "0"
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createReportExport(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("导出")]
                                )
                              : _vm._e(),
                            scope.row.url && scope.row.state + "" == "2"
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDownload(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("下载")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("export-modal", {
        ref: "exportModal",
        attrs: {
          title: "导出校级报告",
          reportList: _vm.reportList,
          "show-six-rete": false,
          "school-all-report": _vm.schoolAllReport,
        },
        on: { "click-item": _vm.clickItem },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("导出报表 "),
      _c("img", {
        staticStyle: { width: "16px", "margin-left": "4px" },
        attrs: { src: require("../../assets/images/export-report.png") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }